// extracted by mini-css-extract-plugin
module.exports = {"modalLayout":"Modal_modalLayout__2l1tI","modalContent":"Modal_modalContent__1AP_v","header":"Modal_header__3jdKb","title":"Modal_title__1gczl","close":"Modal_close__2EfR5"};